/**
 * Worklist row actions, shared by the sales and the support worklist: change
 * an email's status and (re)assign it without leaving the board — the same
 * calls as the inbox queue (salesInbox:status / salesInbox:assign-user).
 *
 * The views render the controls with statusChip() / assignButtons() and route
 * their clicks here; `done` is called once the change is saved, so the view
 * can refetch the board (a status or an assignee can move a card).
 */
define('salesInboxWorklistRowActions',[
  'app',
  'jquery',
  'underscore',
  'settings',
  'entities/sales_inbox'
], function (App, $, _, Settings) {
  'use strict';

  var STATUSES = ['NEW', 'AWAITING', 'RESOLVED'];
  var LABELS = { NEW: 'New', AWAITING: 'Awaiting', RESOLVED: 'Resolved' };

  function currentUserSecId() {
    var user = Settings.get('currentUser');
    return user ? (user.secId || null) : null;
  }

  function closeMenu() {
    $('.wl-status-menu').remove();
    $(document).off('click.wlStatusMenu');
  }

  // Same palette as the "action required DTP" marker of the offer detail
  // header (orders/detail/header/view.html, .ukr-messages).
  var DTP_ICON = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="red" d="M512 256c0 .9 0 1.8 0 2.7c-.4 36.5-33.6 61.3-70.1 61.3H344c-26.5 0-4' +
    '8 21.5-48 48c0 3.4 .4 6.7 1 9.9c2.1 10.2 6.5 20 10.8 29.9c6.1 13.8 12.1 27.5 12.1 42c0 31.8-21.6 60.7-53.4 62c-3.5 .1-7 .2-10.6 .2C114.6 512 0 397.4 0' +
    ' 256S114.6 0 256 0S512 114.6 512 256zM128 288c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zm0-96c17.7 0 32-14.3 32-32s-14.3-32-32-3' +
    '2s-32 14.3-32 32s14.3 32 32 32zM288 96c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zm96 96c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 ' +
    '14.3-32 32s14.3 32 32 32z"/></svg>';

  return {
    /** Palette marker of an offer waiting for the DTP team (actionRequiredUkr). */
    dtpIcon: function (item) {
      if (item.type !== 'OFFER' || !item.graphAction) { return ''; }
      return '<span class="wl-dtp" title="Action required DTP">' + DTP_ICON + '</span>';
    },

    /** Clickable status pill of an email row. */
    statusChip: function (item) {
      var code = String(item.inboxStatus || 'NEW').toUpperCase();
      return '<button type="button" class="wl-status wl-status-btn js-wl-status st-' + code.toLowerCase() +
        '" data-secid="' + _.escape(item.secId || '') + '" data-status="' + code + '" title="Change status">' +
        _.escape(LABELS[code] || code) + ' <span class="caret-s">▾</span></button>';
    },

    /** "Me" (when it is not mine yet) and "Assign…" buttons of an email row. */
    assignButtons: function (item) {
      var mine = currentUserSecId();
      var isMine = !!(mine && item.assignedUserSecId === mine);
      return '<span class="wl-act">' +
        (isMine ? '' : '<button type="button" class="wl-act-btn js-wl-assign-me" data-secid="' +
          _.escape(item.secId || '') + '" title="Assign to me">Me</button>') +
        '<button type="button" class="wl-act-btn js-wl-assign" data-secid="' + _.escape(item.secId || '') +
        '" data-assignee="' + _.escape(item.assignedUserSecId || '') + '" data-assignee-name="' +
        _.escape(item.assignedUserName || '') + '" title="Assign to…"><i class="fa fa-user-plus"></i></button>' +
        '</span>';
    },

    /** Status menu under the clicked pill. */
    openStatusMenu: function ($chip, done) {
      closeMenu();
      var secId = $chip.attr('data-secid');
      var current = $chip.attr('data-status');
      if (!secId) { return; }
      var $menu = $('<div class="wl-status-menu"></div>');
      _.each(STATUSES, function (s) {
        var $opt = $('<button type="button" class="wl-status-opt"></button>')
          .toggleClass('on', s === current)
          .append($('<span class="wl-status"></span>').addClass('st-' + s.toLowerCase()).text(LABELS[s]));
        $opt.on('click', function (e) {
          e.stopPropagation();
          closeMenu();
          if (s === current) { return; }
          $chip.prop('disabled', true);
          App.request('salesInbox:status', secId, s).done(function () {
            if (done) { done(); }
          }).fail(function () {
            $chip.prop('disabled', false);
          });
        });
        $menu.append($opt);
      });
      var off = $chip.offset();
      $menu.css({ top: off.top + $chip.outerHeight() + 4, left: off.left });
      $('body').append($menu);
      // Deferred so the click that opened the menu does not close it at once.
      _.defer(function () {
        $(document).on('click.wlStatusMenu', closeMenu);
      });
    },

    assignMe: function (secId, done) {
      var mine = currentUserSecId();
      if (!secId || !mine) { return; }
      App.request('salesInbox:assign-user', secId, mine).done(function () {
        if (done) { done(); }
      });
    },

    /** The shared user picker, as on the inbox queue. */
    openAssignee: function ($btn, done) {
      var secId = $btn.attr('data-secid');
      if (!secId) { return; }
      var currentSecId = $btn.attr('data-assignee');
      var currentName = $btn.attr('data-assignee-name');
      require(['userSelectorView', 'backbone'], function (UserSelectorView, Backbone) {
        var preselected = [];
        if (currentSecId) {
          preselected.push(new Backbone.Model({ secId: currentSecId, fullName: currentName || '', email: '' }));
        }
        UserSelectorView.prototype.open({
          users: preselected,
          multiselect: false,
          onSelected: function (user) {
            var defer = $.Deferred();
            App.request('salesInbox:assign-user', secId, user.get('secId')).done(function () {
              defer.resolve();
              if (done) { done(); }
            }).fail(function () { defer.reject(); });
            return defer.promise();
          },
          onUnSelected: function () {
            var defer = $.Deferred();
            App.request('salesInbox:assign-user', secId, null).done(function () {
              defer.resolve();
              if (done) { done(); }
            }).fail(function () { defer.reject(); });
            return defer.promise();
          }
        });
      });
    },

    closeMenu: closeMenu
  };
});

